<!--
 * @Author: Junjie
 * @Date: 2022-09-14 17:06:08
 * @LastEditTime: 2023-01-13 23:55:44
 * @email: 781433561@qq.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/views/tech/read/modules/IotSensorReadAddModal.vue
-->
<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <iot-sensor-read-add-form :disabled="disableSubmit" @ok="submitCallback" ref="realForm"></iot-sensor-read-add-form>
  </j-modal>
</template>

<script>

  import IotSensorReadAddForm from './IotSensorReadAddForm'
  export default {
    name: 'IotSensorReadAddModal',
    components: {
      IotSensorReadAddForm
    },
    data () {
      return {
        title: '',
        width: 1200,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      add () {
        this.visible = true
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback () {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';

  /deep/ .ant-modal-body {
    padding: 6px;
    max-height: none !important;
  }

  /deep/ .ant-form-item {
    margin-bottom: 3px;
  }
</style>